(function () {
  const shared = (window.RivyoShared = window.RivyoShared || {});
  if (!shared.productReviewCache) {
    shared.productReviewCache = new Map();
  }

  function getConfig() {
    const cfg = window.RivyoConfig || {};
    if (!cfg.proxyUrl || !cfg.shop) return null;
    return cfg;
  }

  function formatCount(value) {
    return new Intl.NumberFormat("en-US").format(value);
  }

  function getMediaUrl(review) {
    if (!review) return "";
    const media = Array.isArray(review.media) ? review.media : [];
    if (media.length && media[0] && media[0].review_img) {
      return media[0].review_img;
    }
    return "";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  async function fetchProductReviews(cfg, productId, productHandle, options = {}) {
    if (!cfg || !productId || !productHandle) return null;
    const sortBy = options.sortBy || "recent-review";
    const page = String(options.page || 1);
    const key = `${productId}:${productHandle}:${sortBy}:${page}`;
    if (shared.productReviewCache.has(key)) return shared.productReviewCache.get(key);

    const endpoint = new URL(cfg.proxyUrl);
    endpoint.searchParams.set("action", "product_reviews");
    endpoint.searchParams.set("shop", cfg.shop);
    endpoint.searchParams.set("product_id", String(productId));
    endpoint.searchParams.set("product_handle", String(productHandle));
    endpoint.searchParams.set("sort_by", sortBy);
    endpoint.searchParams.set("page", page);

    const promise = fetch(endpoint.toString(), { method: "GET" })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    shared.productReviewCache.set(key, promise);
    return promise;
  }

  shared.getProductReviews = fetchProductReviews;

  function renderCountText(payload, includeRating) {
    if (!payload) return null;
    const total = Number(payload.total_review || 0);
    if (!Number.isFinite(total) || total <= 0) return null;

    const formattedCount = formatCount(total);
    if (!includeRating) return `${formattedCount} reviews`;

    const rating = Number(payload.base_rating || 0);
    if (!Number.isFinite(rating) || rating <= 0) return `${formattedCount} reviews`;
    return `★ ${rating.toFixed(1)} (${formattedCount} reviews)`;
  }

  async function updateCountElements(selector, includeRating) {
    const cfg = getConfig();
    if (!cfg) return;

    const nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    for (const node of nodes) {
      const productId = node.dataset.productId || cfg.product?.id;
      const productHandle = node.dataset.productHandle || cfg.product?.handle;
      if (!productId || !productHandle) continue;

      const payload = await fetchProductReviews(cfg, productId, productHandle);
      const text = renderCountText(payload, includeRating);
      if (!text) continue;

      node.textContent = text;
      node.removeAttribute("hidden");
      node.classList.add("rivyo-badge-ready");
    }
  }

  async function updatePhotoReviewSections() {
    const cfg = getConfig();
    if (!cfg) return;

    const sections = document.querySelectorAll(".rivyo-photos-section");
    if (!sections.length) return;

    for (const section of sections) {
      const productId = section.dataset.productId || cfg.product?.id;
      const productHandle = section.dataset.productHandle || cfg.product?.handle;
      const sortBy = section.dataset.sortBy || "pictures-first";
      const limit = Number(section.dataset.limit || 6);

      if (!productId || !productHandle) continue;

      const payload = await fetchProductReviews(cfg, productId, productHandle, { sortBy, page: 1 });
      const grid = section.querySelector(".rivyo-photos-grid");
      if (!grid) continue;

      const reviews = Array.isArray(payload?.reviews) ? payload.reviews : [];
      const withMedia = reviews.filter((review) => getMediaUrl(review));
      const take = withMedia.slice(0, Number.isFinite(limit) && limit > 0 ? limit : 6);

      if (!take.length) {
        grid.innerHTML = '<p class="rivyo-photos-empty">No photo reviews found yet.</p>';
        continue;
      }

      grid.innerHTML = take
        .map((review) => {
          const img = escapeHtml(getMediaUrl(review));
          const name = escapeHtml(review.name || "Customer");
          const rating = Number(review.rating || 0);
          const body = (review.review_body || "").trim();
          const safeBody = escapeHtml(body.length > 140 ? `${body.slice(0, 137)}...` : body);
          return `
            <article class="rivyo-photo-card">
              <img src="${img}" alt="Customer review photo from ${name}" loading="lazy">
              <div class="rivyo-photo-card__meta">
                <strong>${name}</strong>
                <span>${rating > 0 ? `★ ${rating}` : ""}</span>
              </div>
              ${safeBody ? `<p>${safeBody}</p>` : ""}
            </article>
          `;
        })
        .join("");
    }
  }

  async function init() {
    await updateCountElements(".clnf-plus-reviews-count", false);
    await updateCountElements(".rivyo-instant-badge", true);
    await updatePhotoReviewSections();
  }

  if (window.loadScheduler && typeof window.loadScheduler.onDomContentLoaded === "function") {
    window.loadScheduler.onDomContentLoaded(init);
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
